import type { Configuration, CreateConfigRequest, DirectoryItem, UpdateConfigRequest } from "@/models/themes.model"
import type { HttpClient } from "@/services/http-common"
import ApiServiceFactory from "@/services/api-service-factory"

export class ConfigurationService {
  private httpClient: HttpClient
  private readonly baseUrl: string = "/configurations"

  constructor(httpClient: HttpClient) {
    this.httpClient = httpClient
  }

  async fetchConfigurations() {
    const response = await this.httpClient.get<Configuration[]>(`${this.baseUrl}/`)
    console.log("ConfigurationService.fetchConfigurations", response)
    return response
  }

  async createConfiguration(configuration: Configuration, file?: File) {
    const formData = new FormData()
    formData.append("configuration", JSON.stringify(configuration))
    if (file) {
      formData.append("file", file)
    }
    const response = await this.httpClient.post<Configuration>(`${this.baseUrl}/`, formData)
    console.log("ConfigurationService.createConfiguration", response)
    return response
  }

  async updateConfiguration(configuration: Configuration, file?: File) {
    const formData = new FormData()
    formData.append("configuration", JSON.stringify(configuration))
    if (file) {
      formData.append("file", file)
    }
    const response = await this.httpClient.put<Configuration>(`${this.baseUrl}/${configuration.id}`, formData)
    console.log("ConfigurationService.updateConfiguration", response)
    return response
  }

  async deleteConfiguration(configuration: Configuration) {
    const response = await this.httpClient.delete<Configuration>(`${this.baseUrl}/${configuration.id}`)
    console.log("ConfigurationService.deleteConfiguration", response)
    return response
  }

  async createBulkConfiguration(configurations: CreateConfigRequest[]) {
    const response = await this.httpClient.post<Configuration[]>(`${this.baseUrl}/bulk`, configurations)
    console.log("ConfigurationService.createBulkConfiguration", response)
    return response
  }

  async updateBulkConfiguration(configurations: Array<{ id: Configuration["id"], dto: UpdateConfigRequest }>) {
    const response = await this.httpClient.put<Configuration[]>(`${this.baseUrl}/bulk`, configurations)
    console.log("ConfigurationService.updateBulkConfiguration", response)
    return response
  }

  async getDisciplineLogoDirectory() {
    const response = await this.httpClient.get<DirectoryItem[]>(`${this.baseUrl}/discipline-logos`)
    console.log("ConfigurationService.getDisciplineLogoDirectory", response)
    return response
  }

  async uploadDisciplineLogo(file: File) {
    const formData = new FormData()
    formData.append("file", file)
    // we dont care about the response, we just want to upload the file
    const response = await this.httpClient.post<unknown>(`${this.baseUrl}/discipline-logos`, formData)
    console.log("ConfigurationService.uploadDisciplineLogo", response)
    return response
  }

  async deleteImage(path: string, configCode: string = "discipline_images") {
    const response = await this.httpClient.delete<unknown>(`${this.baseUrl}/images/${configCode}/${path}`)
    console.log("ConfigurationService.deleteImage", response)
    return response
  }
}

export const configurationService = ApiServiceFactory.createService(ConfigurationService, "configuration")
export default ConfigurationService
